import { render, staticRenderFns } from "./DashboardHead.vue?vue&type=template&id=0f0c16ec&scoped=true&"
import script from "./DashboardHead.vue?vue&type=script&lang=ts&"
export * from "./DashboardHead.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardHead.vue?vue&type=style&index=0&id=0f0c16ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c16ec",
  null
  
)

export default component.exports